// src/hooks/useForm.ts
import { useState, useCallback } from "react";

type Validator<T> = (values: T) => string | null;

export const useForm = <T extends Record<string, any>>(initialValues: T, validators: Partial<Record<keyof T, Validator<T>>>) => {
  const [values, setValues] = useState<T>(initialValues);

  const handleChange = useCallback((field: keyof T, value: any) => {
    setValues((prev) => ({ ...prev, [field]: value }));
  }, []);

  const validate = useCallback(() => {
    for (const key in validators) {
      const validator = validators[key];
      if (validator) {
        const error = validator(values);
        if (error) return { isValid: false, error };
      }
    }
    return { isValid: true, error: null };
  }, [validators, values]);

  return {
    values,
    handleChange,
    validate,
    setValues,
  };
};
